/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiServerErrNoRolesGet } from '../fn/server/api-server-err-no-roles-get';
import { ApiServerErrNoRolesGet$Params } from '../fn/server/api-server-err-no-roles-get';
import { apiServerInitEmailTemplatePost } from '../fn/server/api-server-init-email-template-post';
import { ApiServerInitEmailTemplatePost$Params } from '../fn/server/api-server-init-email-template-post';
import { apiServerSmtpTestPost } from '../fn/server/api-server-smtp-test-post';
import { ApiServerSmtpTestPost$Params } from '../fn/server/api-server-smtp-test-post';

@Injectable({ providedIn: 'root' })
export class ServerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiServerInitEmailTemplatePost()` */
  static readonly ApiServerInitEmailTemplatePostPath = '/api/server/init-email-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerInitEmailTemplatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerInitEmailTemplatePost$Response(params?: ApiServerInitEmailTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiServerInitEmailTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerInitEmailTemplatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerInitEmailTemplatePost(params?: ApiServerInitEmailTemplatePost$Params, context?: HttpContext): Observable<string> {
    return this.apiServerInitEmailTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiServerSmtpTestPost()` */
  static readonly ApiServerSmtpTestPostPath = '/api/server/smtp-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerSmtpTestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerSmtpTestPost$Response(params?: ApiServerSmtpTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiServerSmtpTestPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerSmtpTestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerSmtpTestPost(params?: ApiServerSmtpTestPost$Params, context?: HttpContext): Observable<string> {
    return this.apiServerSmtpTestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiServerErrNoRolesGet()` */
  static readonly ApiServerErrNoRolesGetPath = '/api/server/err-no-roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerErrNoRolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerErrNoRolesGet$Response(params?: ApiServerErrNoRolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiServerErrNoRolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerErrNoRolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerErrNoRolesGet(params?: ApiServerErrNoRolesGet$Params, context?: HttpContext): Observable<string> {
    return this.apiServerErrNoRolesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
